
export function buildTreeKeyToRootColumnMap(treeNodes) {
  const keyToRoot = new Map()
  const walk = (nodes, rootKey = undefined) => {
    for (const node of nodes || []) {
      if (node?.key == null) continue
      const columnRoot = rootKey ?? node.key
      keyToRoot.set(node.key, columnRoot)
      if (node.children?.length) {
        walk(node.children, columnRoot)
      }
    }
  }
  walk(treeNodes, undefined)
  return keyToRoot
}

export function normalizeTreeCheckedPayloadToLeafKeys(checkedPayload) {
  if (Array.isArray(checkedPayload)) return checkedPayload
  if (checkedPayload?.checked != null) return [...checkedPayload.checked]
  return []
}

export function countDistinctTreeParentRoots(leafKeys, treeData) {
  const map = buildTreeKeyToRootColumnMap(treeData)
  const roots = new Set()
  for (const key of leafKeys || []) {
    roots.add(map.get(key) ?? key)
  }
  return roots.size
}

export function exceedsTreeParentLimit(leafKeys, treeData, maxParents) {
  if (maxParents == null || maxParents <= 0) return false
  return countDistinctTreeParentRoots(leafKeys, treeData) > maxParents
}

function collectLeafKeysUnderNode(node) {
  if (node?.key == null) return []
  if (!node.children?.length) return [node.key]
  return node.children.flatMap(collectLeafKeysUnderNode)
}

export function buildSelectAllLeafKeys(treeData, options = {}) {
  const { restrictToParentKeys = null, maxDistinctParentRoots = null } = options
  if (!treeData?.length) return []
  const top = treeData.filter(n => n?.key != null)
  const orderedRoots =
    restrictToParentKeys?.length > 0
      ? restrictToParentKeys.map(k => top.find(n => n.key === k)).filter(Boolean)
      : top
  let acc = []
  for (const root of orderedRoots) {
    const leaves = collectLeafKeysUnderNode(root)
    const next = [...acc, ...leaves]
    if (maxDistinctParentRoots != null && maxDistinctParentRoots > 0) {
      if (countDistinctTreeParentRoots(next, treeData) > maxDistinctParentRoots) {
        break
      }
    }
    acc = next
  }
  return acc
}
